<script>
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import DialogContentInput from "../../../../components/dialog/DialogContentInput.svelte";
  import HelpTooltip from "../../../../components/tooltip/HelpTooltip.svelte";
  import { getNotificationsContext } from "svelte-notifications";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import { downloadFile } from "../../../../utils/download.js";
  import { useInvalidateLicenseData } from "../../../../hooks/license/useLicenseData.js";
  import { translate } from "../../../../i18n/i18next.js";

  const {addNotification} = getNotificationsContext()
  const {invalidateLicenseData} = useInvalidateLicenseData()

  export let onClose

  let fileInput

  let isSubmitting = false
  async function handleSubmit() {
    isSubmitting = true

    const files = fileInput?.files ?? []
    // reject if no file is selected
    if (files.length === 0) return

    let content
    try {
      content = await files[0].text()
    } catch (e) {
      addNotification({
        text: translate("frontend:components.applyCancelFileDialog.messages.failedToReadCancelFile"),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });

      isSubmitting = false

      return
    }

    const response = await fetch("/api/license/e-protector/cancel", {
      method: "POST",
      body: JSON.stringify({
        content,
        filename: files[0].name
      }),
      headers: {
        "Content-Type": "application/json",
      }
    })

    const responseData = await response.json().catch(() => null)
    if (response.ok) {
      downloadFile(new Blob([responseData.content]), responseData.filename)
      addNotification({
        text: translate("frontend:components.applyCancelFileDialog.messages.haspCancelled"),
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });
      isSubmitting = false
      onClose()
      await invalidateLicenseData()
    } else {
      addNotification({
        text: translate("frontend:components.applyCancelFileDialog.messages.haspCancellationFailed", null, {error: responseData?.type}),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
      isSubmitting = false
    }
  }
</script>

<DialogTitle title={translate("frontend:components.applyCancelFileDialog.title")}></DialogTitle>
<DialogSplitter/>
<DialogContent>
  <form>
    <DialogContentInput name="cancelFile" type="file" bind:inputThis={fileInput}>
      <span slot="label">
        {translate("frontend:components.applyCancelFileDialog.fileInput.label")}
      </span>
      <HelpTooltip title={translate("generic.license.hasp.cancelFile")}>
        {translate("frontend:components.applyCancelFileDialog.fileInput.tooltip")}
      </HelpTooltip>
    </DialogContentInput>
  </form>
</DialogContent>
<DialogBottomControls>
  <DialogBottomControlButton type="primary" onClick={handleSubmit} disabled={isSubmitting}>
    {translate("generic.apply")}
  </DialogBottomControlButton>
  <DialogBottomControlButton type="secondary" onClick={onClose}>
    {translate("generic.cancel")}
  </DialogBottomControlButton>
</DialogBottomControls>
